import HeaderComponent from "components/card/HeaderComponent";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAttendanceSummary } from "../../../../redux/overview/overviewState";
import { Table } from "antd";
import { handleTableChange } from "../../../../utils/index";
import { LucideCircleCheck, LucideCircleX, LucideClock } from "lucide-react";
import { NumberFormatter } from "../../../../utils/index";

const EmployeeAttendanceTable = ({ doSearch, recordList, filters, date, startDate, endDate }) => {

  useEffect(() => {
    if (startDate && endDate) {
      doSearch({ start_date: startDate, end_date: endDate });
    }
  }, [doSearch, startDate, endDate]);

  const recordsRate = (recordList.overview || []).map((r) => {
    const attendance_rate =
      (r.present_days / (r.present_days + r.absent_days)) * 100 || 0;
    return { ...r, attendance_rate };
  });

  const columns = [
    {
      title: "Employee",
      dataIndex: "employee_name",
      key: "employee_name",
      width: "20%",
      render: (employee_name, record) => (
        <span className="flex flex-col gap-1">
          <div className="font-medium">{employee_name}</div>
          <div className="text-gray-600 text-xs">{record.emp_code}</div>
        </span>
      ),
    },
    {
      title: "Present Days",
      dataIndex: "present_days",
      key: "present_days",
      width: "15%",
      render: (present_days) => (
        <div className="flex items-center gap-1">
          <LucideCircleCheck size={16} className="text-green-600" />
          <span>{present_days}</span>
        </div>
      ),
    },
    {
      title: "Absent Days",
      dataIndex: "absent_days",
      key: "absent_days",
      width: "15%",
      render: (absent_days) => (
        <div className="flex items-center gap-1">
          <LucideCircleX size={16} className="text-red-600" />
          <span>{absent_days}</span>
        </div>
      ),
    },
    {
      title: "Late Arrivals",
      dataIndex: "late_days",
      key: "late_days",
      width: "15%",
      render: (late_days) => (
        <div className="flex items-center gap-1">
          <LucideClock size={16} className="text-orange-600" />
          <span>{late_days}</span>
        </div>
      ),
    },
    {
      title: "Attendance Rate",
      dataIndex: "attendance_rate",
      key: "attendance_rate",
      width: "15%",
      render: (attendanceRate) => `${NumberFormatter(attendanceRate, 2)}%`,
    },
    {
      title: "Status",
      key: "status",
      width: "20%",
      render: (_, record) => {
        const attendanceRate = record.attendance_rate;
        let status = "";

        if (attendanceRate > 90) {
          status = "Excellent";
        } else if (attendanceRate >= 85) {
          status = "Good";
        } else {
          status = "Needs Attention";
        }

        return (
          <div
            className={`status-indicator ${status
              .toLowerCase()
              .replace(/\s+/g, "-")} text-xs`}
          >
            {status}
          </div>
        );
      },
    },

  ];

  return (
    <HeaderComponent
      title="Employee Attendance Records"
      description={`Individual attendance summary for ${date.format("MMMM YYYY")}`}
    >
      <Table
        dataSource={recordsRate} 
        columns={columns}
        rowKey={(record) => record.user_id}
        pagination={false}
        onChange={handleTableChange(doSearch, filters)}
      />
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.overview.employeeAttendanceRecord?.data || { overview: [], totals: {} },
  requesting: state.overview.employeeAttendanceRecord?.requesting,
  error: state.overview.employeeAttendanceRecord?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAttendanceSummary(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttendanceTable);
